import { render, staticRenderFns } from "./recipient-name.vue?vue&type=template&id=24304337"
import script from "./recipient-name.vue?vue&type=script&lang=js"
export * from "./recipient-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports